module.exports = __webpack_public_path__ + "media/icons/raport_2@2x-d13c8981.png";